import { SelectedLabels } from '@kosmos/shared';

export const DisplayLabels = ({metadatas}: { metadatas?: SelectedLabels}) => {

    const labelsElement = [];
    if (metadatas) {
        for (const key in metadatas) {
            const meta = metadatas[key];

            if (meta) {
                labelsElement.push(<div className={"label"}><strong>{key} :</strong> {meta.toString().replace(/["[\]"]/g, "")}</div>)
            }
        }
    }
    return <>{labelsElement}</>;

}